app.controller(
    'AdminUserCreation', ['$scope', 'toastr', AdminUserCreation]
);

function AdminUserCreation($scope, toastr) {

    /**
     * Simulation succes form
     * @method
     * @return {[type]} [description]
     */
    $scope.validMail = '';
    $scope.validName = '';
    $scope.validFirstname = '';
    $scope.validRole = '';
    $scope.validLang = '';

    $scope.create = function () {

        $scope.validateMail = function (mail) {
            var regMail = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            $scope.validMail = regMail.test(mail);
        };

        $scope.validateName = function (name) {
            var regName = /^[A-Z]|[a-z]/;
            $scope.validName = regName.test(name);
        };

        $scope.validateFirstname = function (firstname) {
            var regFirstname = /^[A-Z]|[a-z]/;
            $scope.validFirstname = regFirstname.test(firstname);
        };

        $scope.validateRole = function (role) {
            $scope.validRole = ( role === "Traducteur" || 'Administrateur' || 'Correcteur' || 'Secrétaire de rédaction' ) ? true : false ;
        };

        $scope.validateLang = function (lang1,lang2) {
            console.log('@0',$scope.validLang);

            if ( $scope.validRole === 'Traducteur')
            {
                $scope.validLang = (lang1 != '' && lang2 != '' ) ? true : false ;
            }
            else {
                $scope.validLang = (lang1 == '') ? false : true ;
            }
        };
        if ($scope.validMail && $scope.validName && $scope.validFirstname && $scope.validRole && $scope.validLang)
        {
            toastr.success('Le compte utilisateur a bien été créé.');
        }
        else {
            if (!$scope.validMail || $scope.validMail === '' ){
                toastr.error('E-Mail non valide ');
            }
            if (!$scope.validName || $scope.validName === '' ){
                toastr.error('Nom non valide');
            }
            if (!$scope.validFirstname || $scope.validFirstname === ''){
                toastr.error('Prénoms non valide');
            }
            if (!$scope.validRole || $scope.validRole === ''){
                toastr.error('Rôle non valide');
            }
            if (!$scope.validLang || $scope.validLang === ''){
                toastr.error('Langue non valide');
            }
        }
    };

    $scope.roleLang = [
        {
            name: 'Traducteur',
            openTranslation: true
        },
        {
            name: 'Administrateur',
            openTranslation: false
        },
        {
            name: 'Correcteur',
            openTranslation: false
        },
        {
            name: 'Secrétaire de rédaction',
            openTranslation: false
        }
    ];


};